import { useQuery } from '@tanstack/react-query'
import { organizationApi, type OrganizationProfile } from '../../api/organization/organization.api'

export const ORG_PROFILE_QUERY_KEY = ['organization', 'profile']

export function useOrganizationProfile() {
  return useQuery<OrganizationProfile>({
    queryKey: ORG_PROFILE_QUERY_KEY,
    queryFn: organizationApi.getMyOrganizationProfile,
    staleTime: 5 * 60 * 1000,
  })
}
